import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  children: React.ReactNode;
}

function AccordionSectionButtonContainer({ children }: Props) {
  const classes = useStyles();
  return <div className={classes.buttonContainer}>{children}</div>;
}

const useStyles = makeStyles(theme => ({
  root: {},
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: 24,
    paddingTop: 16,
  },
}));

export default AccordionSectionButtonContainer;
